import i18n from '../../../../../i18n'
import { getTranslatedName } from '../../../utils/functions/translation.functions'
import { staffQualificationEnumMapping } from '../../enums/staff/staff-qualifications.enum'
import { StaffRequest, StaffRequestInfo } from './staff-request'

export class StaffRequestProperties {
  static getCoursesStaffRequests(staffRequests: StaffRequest[]): StaffRequest[] {
    return staffRequests.filter(
      (r) => staffQualificationEnumMapping[r.qualification].profession === 'course'
    )
  }

  static getActivitiesStaffRequests(staffRequests: StaffRequest[]): StaffRequest[] {
    return staffRequests.filter(
      (r) => staffQualificationEnumMapping[r.qualification].profession === 'activity'
    )
  }

  static getFormulaName(staffRequest: StaffRequest): string {
    return staffRequest.formulas
      .map((formula) => getTranslatedName(formula, i18n.language) || '—')
      .join('- ')
  }

  static getPeriod(staffRequest: StaffRequestInfo) {
    return staffRequest.centers.at(0)?.centerToJourneys.at(0)?.journey.date.period
  }

  //check if staffRequest qualification is Foreign
  static isForeignStaff(staffRequest: Pick<StaffRequest, 'qualification'>): boolean {
    return staffQualificationEnumMapping[staffRequest.qualification].type === 'foreign'
  }
}
